import * as tslib_1 from "tslib";
import { m } from '../hyperscript';
export function wrap(layoutView, options) {
    if (options === void 0) { options = {}; }
    return function (component) {
        var comp = function (_a) {
            var children = _a.children, attrs = tslib_1.__rest(_a, ["children"]);
            return m(layoutView, tslib_1.__assign({}, attrs, options), m(component, attrs, children));
        };
        return comp;
    };
}
